import React from 'react';
import {
  Card,
  Row,
  Col,
  Form,
  Button,
  Badge,
  InputGroup,
  DropdownButton,
  Dropdown,
} from 'react-bootstrap';
import { FaCheck, FaFilter, FaTimes } from 'react-icons/fa';

const contarFiltrosAtivos = (values) => {
  let total = 0;
  if (values.geId) total += 1;
  if (values.grupoGeId) total += 1;
  if (values.tipos && values.tipos.length < 6) total += 1;
  if (values.status !== '0') total += 1;
  if (values.modoListagem !== 0) total += 1;
  if (values.exibirImobilizado) total += 1;
  if (values.conversaoMoeda) total += 1;
  return total;
};

const CardGeracao = ({ formik, onAbrirFiltros, onLimpar }) => {
  const filtrosAtivos = contarFiltrosAtivos(formik.values);

  const isCodigo = formik.values.qtipoTab === 'codigo';
  const labelBase = isCodigo ? 'Código' : 'Nome';
  const inputType = isCodigo ? 'number' : 'text';
  const inputMaxLength = isCodigo ? undefined : 30;

  const trocarTipo = (novoTipo) => {
    if (novoTipo === formik.values.qtipoTab) return;
    formik.setFieldValue('qtipoTab', novoTipo);
    formik.setFieldValue('codIni', null);
    formik.setFieldValue('codFim', null);
    formik.setFieldValue('nomeIni', '');
    formik.setFieldValue('nomeFim', '');
    formik.setErrors({});
    formik.setTouched({});
  };

  const handleFiltrar = () => {
    let qtipo;
    if (isCodigo) {
      const temIntervalo =
        formik.values.codIni != null && formik.values.codFim != null;
      qtipo = temIntervalo ? 1 : 0;
    } else {
      const temIntervalo =
        formik.values.nomeIni !== '' && formik.values.nomeFim !== '';
      qtipo = temIntervalo ? 3 : 2;
    }
    formik.setFieldValue('qtipo', qtipo, false);
    setTimeout(() => formik.submitForm(), 0);
  };

  const valorIni = isCodigo
    ? formik.values.codIni != null
      ? formik.values.codIni
      : ''
    : formik.values.nomeIni;
  const valorFim = isCodigo
    ? formik.values.codFim != null
      ? formik.values.codFim
      : ''
    : formik.values.nomeFim;

  const erroIni = isCodigo ? formik.errors.codIni : formik.errors.nomeIni;
  const erroFim = isCodigo ? formik.errors.codFim : formik.errors.nomeFim;

  const handleChangeIni = (e) => {
    const valor = e.target.value;
    if (isCodigo) {
      formik.setFieldValue(
        'codIni',
        valor !== '' ? parseInt(valor, 10) : null
      );
    } else {
      formik.setFieldValue('nomeIni', valor);
    }
  };

  const handleChangeFim = (e) => {
    const valor = e.target.value;
    if (isCodigo) {
      formik.setFieldValue(
        'codFim',
        valor !== '' ? parseInt(valor, 10) : null
      );
    } else {
      formik.setFieldValue('nomeFim', valor);
    }
  };

  return (
    <Card className="mb-3 shadow-sm">
      <Card.Header className="bg-white d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <strong>Geração</strong>
        </div>
        <Button
          variant="outline-primary"
          size="sm"
          onClick={onAbrirFiltros}
          type="button"
        >
          <FaFilter className="mr-1" />
          Filtros
          {filtrosAtivos > 0 && (
            <Badge variant="primary" pill className="ml-2">
              {filtrosAtivos}
            </Badge>
          )}
        </Button>
      </Card.Header>
      <Card.Body>
        <Row className="align-items-end">
          <Col xs={12} sm={6} md={3} className="mb-2">
            <Form.Label className="small mb-1">{`${labelBase} inicial`}</Form.Label>
            <Form.Control
              size="sm"
              type={inputType}
              maxLength={inputMaxLength}
              value={valorIni}
              onChange={handleChangeIni}
              isInvalid={!!erroIni}
            />
            <Form.Control.Feedback type="invalid">
              {erroIni}
            </Form.Control.Feedback>
          </Col>
          <Col xs={12} sm={6} md={4} className="mb-2">
            <Form.Label className="small mb-1">{`${labelBase} final`}</Form.Label>
            <InputGroup size="sm">
              <Form.Control
                size="sm"
                type={inputType}
                maxLength={inputMaxLength}
                value={valorFim}
                onChange={handleChangeFim}
                isInvalid={!!erroFim}
              />
              <DropdownButton
                as={InputGroup.Append}
                alignRight
                variant="outline-secondary"
                size="sm"
                title={labelBase}
                id="dropdown-tipo-listagem-ativos"
              >
                <Dropdown.Item
                  active={isCodigo}
                  onClick={() => trocarTipo('codigo')}
                >
                  Código
                </Dropdown.Item>
                <Dropdown.Item
                  active={!isCodigo}
                  onClick={() => trocarTipo('descricao')}
                >
                  Nome
                </Dropdown.Item>
              </DropdownButton>
            </InputGroup>
            {erroFim && (
              <div className="invalid-feedback d-block">{erroFim}</div>
            )}
          </Col>
          <Col xs={12} md className="mb-2 d-flex">
            <Button
              variant="primary"
              size="sm"
              className="mr-2 flex-fill"
              type="button"
              onClick={handleFiltrar}
            >
              <FaCheck className="mr-1" />
              Filtrar
            </Button>
            <Button
              variant="outline-secondary"
              size="sm"
              className="flex-fill"
              type="button"
              onClick={onLimpar}
            >
              <FaTimes className="mr-1" />
              Limpar
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default CardGeracao;
